export default __webpack_public_path__ + "static/media/estoura_baloes.cb31bbee.png";